module.exports = __webpack_public_path__ + "static/media/gs-back.16f02402.png";